'use strict';

module.exports = () => {
    const $services = $('.services-slider');
    if (!$services.length || !$.fn.slick) return;

    const $wrapperNav = $services.closest('.section-services__wrapper');
    const BREAKPOINT = 768;

    const enableSlick = () => {
        if ($services.hasClass('slick-initialized')) return;

        $services.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            appendDots: $wrapperNav.find('.slick-pagination'),
            centerMode: false,
            variableWidth: true,
        });
    };

    const disableSlick = () => {
        if (!$services.hasClass('slick-initialized')) return;
        $services.slick('unslick');
    };

    const checkSlick = () => {
        if (window.innerWidth < BREAKPOINT) {
            enableSlick();
        } else {
            disableSlick();
        }
    };

    // init при загрузке
    checkSlick();

    // destroy / init при resize
    window.addEventListener('resize', checkSlick);
};